import { render, staticRenderFns } from "./DomainConnectModal.vue?vue&type=template&id=c7dff8f4&scoped=true&"
import script from "./DomainConnectModal.vue?vue&type=script&lang=js&"
export * from "./DomainConnectModal.vue?vue&type=script&lang=js&"
import style0 from "./DomainConnectModal.vue?vue&type=style&index=0&id=c7dff8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dff8f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
